import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CampSiteList from './CampSiteList';
import { useNavigate } from 'react-router-dom';
import { DateRange } from './types';

interface CampSite {
    id: number;
    name: string;
    location: string;
    capacity: number;
    description: string;
    pricePerNight: number;
    imageUrls: ImageUrl[];
}

interface ImageUrl {
    id: number;
    url: string;
}

const CampSiteManager: React.FC = () => {
    const [campsites, setCampsites] = useState<CampSite[]>([]);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [dateRange, setDateRange] = useState<DateRange>({ startDate: null, endDate: null });

    const apiUrl = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('accessToken');

    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${apiUrl}/CampSite/getAllCampSites`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => setCampsites(data))
            .catch(error => console.error("Error fetching campsites", error));
    }, [apiUrl, token]);

    const handleAddCampsite = () => {
        navigate('/campsite/add', { state: { isEditing: false } });
    };

    const handleEditCampsite = (campsite: CampSite) => {
        navigate(`/campsite/edit/${campsite.id}`, { state: { isEditing: true } });
    };

    const handleDeleteCampsite = async (id: number) => {
        try {
            await axios.delete(`${apiUrl}/CampSite/deleteCampSite/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setCampsites(campsites.filter(c => c.id !== id));
        } catch (error) {
            console.error("Error deleting campsite", error);
        }
    };

    const handleViewCampsite = (campsite: CampSite) => {
        navigate(`/campsite/${campsite.id}`, { state: { dateRange }, replace: true });
    };

    return (
        <section className='campsitemanager-section'>
            <div className="container">
                <div className="button-container">
                    <button className="button" onClick={handleAddCampsite}>
                        Add Campsite
                    </button>
                </div>
                <div className="card">
                    <div className="card-body">
                        <CampSiteList
                            campsites={campsites}
                            onEdit={handleEditCampsite}
                            onDelete={handleDeleteCampsite}
                            onView={handleViewCampsite}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CampSiteManager;